document.querySelectorAll('[data-lineup]').forEach(stage => {
  const items = [...stage.querySelectorAll('.lineup-item')];
  let active = -1;
  let familyHover = false;
  function arrange() {
    const w = stage.clientWidth;
    const astro = stage.dataset.lineup === 'astroskin';
    const family = stage.dataset.lineup === 'family';
    const h = family ? Math.min(440, Math.max(210, w * .65)) : astro ? Math.min(580, w * 1.02) : Math.min(330, Math.max(180, w * .62));
    stage.style.height = h + 'px';
    const widths = items.map(item => h * Number(item.dataset.scale) * Number(item.dataset.ratio));
    const n = family ? items.length : items.length - 1;
    const gap = Math.min(24, w * .018);
    const available = w * .84 - (family ? 0 : widths[n]);
    const natural = widths.slice(0,n).reduce((a,b) => a+b,0) + gap*(n-1);
    const overlap = Math.max(0,(natural-available)/(n-1));
    const total = Math.min(natural,available) + (family ? 0 : widths[n]);
    let x = (w-total)/2;
    const spread = Math.min(24,w*.045);
    items.forEach((item,i) => {
      const left = x;
      item.style.left = left+'px';
      item.style.width = widths[i]+'px';
      item.style.height = h*Number(item.dataset.scale)+'px';
      let shift = active < 0 ? 0 : i < active ? -spread : i > active ? spread : 0;
      if (family) shift = familyHover ? (i-(items.length-1)/2) * Math.min(7,w*.012) : 0;
      item.style.setProperty('--shift', shift+'px');
      item.classList.toggle('is-active',i===active);
      // Keep labels inside the stage, even when the recorder is at the right edge.
      const label=item.querySelector('figcaption');
      const center=left+shift+widths[i]/2;
      const half=(label ? label.getBoundingClientRect().width : 0)/2;
      if(label) label.style.marginLeft=(Math.max(half,Math.min(w-half,center))-center)+'px';
      x += widths[i] + (i<n-1 ? gap-overlap : 0);
    });
  }
  if(stage.dataset.lineup==='family'){
    const link=stage.closest('a');
    for(const event of ['pointerenter','focus']) link.addEventListener(event,()=>{familyHover=true;arrange()});
    for(const event of ['pointerleave','blur']) link.addEventListener(event,()=>{familyHover=false;arrange()});
  }
  items.forEach((item,i) => {
    if(stage.dataset.lineup==='family') return;
    const img=item.querySelector('img');
    img.addEventListener('pointerenter',()=>{active=i;arrange()});
    img.addEventListener('pointerleave',()=>{if(document.activeElement!==img){active=-1;arrange()}});
    img.addEventListener('focus',()=>{active=i;arrange()});
    img.addEventListener('blur',()=>{active=-1;arrange()});
  });
  stage.addEventListener('pointerleave',()=>{active=-1;arrange()});
  new ResizeObserver(arrange).observe(stage);
  arrange();
});
